import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from '@/app/App.vue'
import { router } from '@/app/router'
import { i18n } from '@/core/i18n'
import { installAudienceImagePreload } from '@/core/media/audienceImagePreload'
import { installAudienceManifestProbe } from '@/core/release/manifestProbe'
import 'photoswipe/style.css'
import '@/shared/styles/reset.css'
import '@/shared/styles/structure.css'
import '@/shared/styles/components.css'
import '@/shared/theme/legacy.css'
import '@/shared/theme/theme.css'
import '@/shared/styles/glass.css'

const pinia = createPinia()
const app = createApp(App).use(pinia).use(router).use(i18n)
installAudienceImagePreload(pinia, router)
installAudienceManifestProbe(pinia)
app.mount('#app')
